// Mismas reglas que el textTransform="capitalize"/"sentence" de components/ui/input.tsx,
// para que valores precargados (BD, CV parseado) o guardados sin pasar por el input
// queden normalizados igual que lo que el usuario ve mientras teclea.

/**
 * Capitalizes each word: the first letter after the start, a space, a hyphen or an
 * apostrophe ("o'brien" -> "O'Brien", "ana-maría" -> "Ana-María"). Spaces are kept as they
 * are, so it is safe to apply while the user types.
 */
export function capitalizeWords(value: string): string {
  return value.toLowerCase().replace(/(^|[\s'’-])(\p{L})/gu, (_match, separator: string, letter: string) =>
    separator + letter.toUpperCase(),
  );
}

export function toTitleCase(value: string | null | undefined): string | null {
  if (!value || !value.trim()) return value ?? null;
  return capitalizeWords(value.trim().replace(/\s+/g, " "));
}

export function toSentenceCase(value: string | null | undefined): string | null {
  if (!value || !value.trim()) return value ?? null;
  const text = value.toLowerCase();
  return text.charAt(0).toUpperCase() + text.slice(1);
}
